import actionCreatorFactory from 'typescript-fsa';
import { SemanticArticlesResponse } from '@shared/types/mylounge';
import { NAMESPACE } from './constants';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const fetchingSemanticArticles = actionCreator.async<null, SemanticArticlesResponse, string>(
    'FETCH_SEMANTIC_ARTICLES',
);
